import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const fieldLabelTextStyle = css`
  display: block;
  margin-bottom: ${theme.spacing(1)};
`;

export const errorMessageStyle = css`
  color: ${theme.colors.critical50};
  margin-top: ${theme.spacing(0.5)};
`;

const triggerButtonStyle = css`
  padding: ${theme.spacing(1, 2)};
  border: 1px solid ${theme.colors.neutral30};
  border-radius: ${theme.borderRadius.small};
  cursor: pointer;
  text-align: left;
  width: 100%;

  &:hover {
    border-color: ${theme.colors.primary50};
  }

  &:focus {
    outline: none;
    border-color: ${theme.colors.primary50};
  }
`;

export const getTriggerButtonStyle = (hasError: boolean) => css`
  ${triggerButtonStyle};
  ${hasError &&
  css`
    border-color: ${theme.colors.critical50};

    &:hover {
      border-color: ${theme.colors.critical50};
    }

    &:focus {
      border-color: ${theme.colors.critical50};
    }
  `}
`;

export const labelTextStyle = css`
  color: ${theme.colors.text.subdued};
`;

export const popoverContentStyle = css`
  padding: ${theme.spacing(1.5)};
  min-width: 280px;
`;

export const searchFieldContainerStyle = css`
  margin-bottom: ${theme.spacing(1)};
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: ${theme.spacing(1)};
`;

export const radioListStyle = css`
  overflow-y: auto;
  max-height: min(330px, calc(100vh - 200px));
  padding: ${theme.spacing(1)};
`;

export const listItemStyle = css`
  padding: ${theme.spacing(1)};
`;

export const noResultsContainerStyle = css`
  padding: ${theme.spacing(2)};
  text-align: center;
  color: ${theme.colors.text.subdued};
`;
